module.exports = __webpack_public_path__ + "static/img/brees-2018-slide-6.7db0022.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2018-slide-6.jpg
// module id = C+ek
// module chunks = 1